$(document).ready(function() {
    // ------------------- TB_Testimonial-CMS Start -------------------
        var tb_testimonial_cms =$("#TB-Testimonial-cms .owl-carousel").owlCarousel({
            loop: true,
            center: true,
            margin: 24,
            autoplay: true,
            autoplayTimeout: 2000,
            autoplayHoverPause: true,
            nav: false,
            dots: true,
            responsive: {
                0: {
                items: 1,
                center: false
                },
                576: {
                items: 2
                },
                768: {
                items: 2
                },
                992: {
                items: 3
                },
                1200: {
                items: 4
                },
                1800: {
                items: 6
                }
            }
    });
        // ------------------- TB_Testimonial-CMS End -------------------
        // ------------------- TB_category_featured Start -------------------
            //   var TB_category_featured = $('#TB-category-featured .tb-category-featured-carousel').owlCarousel({
            //     items : 4,
            //     nav :true,
            //     dots : false,
            //     loop: true,
            //     autoplay: true,
            //     autoplayHoverPause: true,
            //     responsive: {
            //         0:{
            //             items:1
            //         },
            //         481:{
            //             items:2
            //         },
            //         768:{
            //             items:2
            //         },
            //         992:{
            //             items:3
            //         },
            //         1300:{
            //             items:4
            //         }
            //     }
            // });
        // ------------------- TB_category_featured End -------------------

        //  var TB_video_CMS = $('#tb-video-cms .owl-carousel').owlCarousel({
        //         loop: false,
        //         margin: 20,
        //         nav: true,
        //         dots: false,
        //         animateOut: 'fadeOut',
        //         animateIn: 'flipInX',
        //         responsive: {
        //             0: { items: 1 },
        //             481: { items: 2 },
        //             768: { items: 3 },
        //             992: { items: 4 },
        //             1300: { items: 4 }
        //         }
        //     });


             var TB_Server_CMS = $('#TB-Server-CMS .owl-carousel').owlCarousel({
                    loop: false,
                    margin: 20,
                    nav: false,
                    dots: false,
                    autoplay:true,
                    animateOut: 'fadeOut',
                    animateIn: 'flipInX',
                    responsive: {
                        0: { items: 1 },
                        481: { items: 2 },
                        768: { items: 3 },
                        992: { items: 4 },
                        1300: { items: 4 }
                    }
                });
 
});


